import { useTheme } from '../lib/theme';
import { Button } from './ui/button';
import { Sun, Moon } from 'lucide-react';

export default function ThemeToggle({ className = '', variant = 'ghost', size = 'icon' }) {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggleTheme}
      className={className}
      data-testid="theme-toggle"
      title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {theme === 'dark' ? (
        <Sun className="w-5 h-5 text-amber-400" />
      ) : (
        <Moon className="w-5 h-5 text-muted-foreground" />
      )}
    </Button>
  );
}
